module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.1-75.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.1.md
// module id = 492
// module chunks = 360